<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <div class="row">
        <div class="col-lg-3 col-md-5 col-sm-12">
          <ts-card class="m-b-15">
            <father-profile v-if="guardianType == 1" />
            <mother-profile v-if="guardianType == 2" />
          </ts-card>
          <ts-card>
            <change-password />
          </ts-card>
          <br />
        </div>
        <div class="col-lg-9 col-md-7 col-sm-12">
          <ts-card>
            <div class="overflow-auto">
              <ts-tabs target="gTab">
                <ts-tab>
                  <i class="fas fa-redo mr-2"></i>
                  {{ $t('homePage.request') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-book mr-2"></i>
                  {{ $t('homePage.homework') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-file-invoice-dollar mr-2"></i>
                  {{ $t('homePage.paymentHistory') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-bell mr-2"></i>
                  {{ $t('homePage.notificationHistory') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-bars mr-2"></i>
                  {{ $t('homePage.details') }}
                </ts-tab>
              </ts-tabs>
            </div>
          </ts-card>
          <ts-tab-panes name="gTab">
            <ts-tab-pane>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <request />
                </div>
              </div>
            </ts-tab-pane>
            <ts-tab-pane>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <homework-list />
                </div>
              </div>
            </ts-tab-pane>
            <ts-tab-pane>
              <payment-history />
            </ts-tab-pane>
            <ts-tab-pane>
              <notification-history />
            </ts-tab-pane>
            <ts-tab-pane>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <student />
                </div>
              </div>
            </ts-tab-pane>
          </ts-tab-panes>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import FatherProfile from './components/father-profile'
import MotherProfile from './components/mother-profile'
import ChangePassword from './components/change-password'
import Request from './components/request'
import HomeworkList from './components/homework-list'
import NotificationHistory from './components/notification-history'
import PaymentHistory from './components/payment-history'
import Student from './components/student'

export default {
  name: 'parentProfile',
  components: {
    FatherProfile,
    MotherProfile,
    ChangePassword,
    Request,
    HomeworkList,
    NotificationHistory,
    PaymentHistory,
    Student
  },
  data() {
    return {
      loadingPreData: false
    }
  },
  created() {
    this.fetchProfile()
  },
  computed: {
    guardianType() {
      return this.$store.state.authUser.guardian_type_id
    }
  },
  methods: {
    fetchProfile() {
      this.loadingPreData = true
      this.$store
        .dispatch('home/parent/fetchProfile')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(() => {
          this.loadingPreData = false
        })
    }
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
